export enum ActiveView {
  PROVIDER = "provider",
  LENDFLOW = "lendflow",
}
